<template>
  <div id="pro_block" class="main_content" style="padding:0">
      <project-list :data="proList"></project-list>
      <!-- <concat-panel></concat-panel> -->
  </div>
</template>

<script>
import {download, getProjects} from '../api/api';
import ConcatPanel from '../components/ConcatPanel.vue';
import ProjectList from '../components/ProjectList.vue';
import zh from "../../i18n/zh";
export default {
  components: {ProjectList  },
  data() {
    return {
      proList:[],
      allList:[]
    };
  },
  mounted(){
    this.$event.on('ImgLoadComplete',(initData)=>{
      if(initData) {
        this.allList = initData.sort((a,b)=>{
          return a.beginDate > b.beginDate ? -1 : 1
        })
        this.proList = this.allList
      } else {
        this.init();
      }
    })
    this.$event.on('menuClick',(menu,subMenu)=>{
      this.projectChange(menu,subMenu)
    })

    this.$event.on('searchChange',(arg)=>{
      this.searchChange(arg)
    })
    this.$event.on('langChange',(arg)=>{
      this.init();
    })
  },
  methods: {
    init(){
      getProjects().then(res => {
        this.allList = res.data.data.sort((a,b)=>{
          return a.beginDate > b.beginDate ? -1 : 1
        })
        this.proList = this.allList
      })
      // download(`project_${this.$i18n.locale}.json`)
    },
    projectChange(type,subType){
      if(type) {
        this.proList = this.allList.filter(item => {
          return item.type.split(',')[0] === type.label
        })
      }

      if(subType) {
        this.proList = this.proList.filter(item => {
          return item.type.split(',')[1] === subType.label
        })
      }
    },
    searchChange(data) {
      if(!data) {
        this.proList = this.allList
        return
      }
      const translate = (data) => {
        return Object.keys(zh).find(key => {
          return zh[key] === data
        }) || data
      }
      console.log(this.allList,data)
      this.proList =  this.allList.filter(item => {
          return item.projectName.includes(data) || item.type.includes(translate(data))
        })
    },


  },
};
</script>

<style  scoped>
.main {
  width: 100%;
  height: 100%;
}


</style>
